import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { TyreTeamCredential } from "models";

export const useUpdateTyreTeamCredentialMutation = () =>
  useTypedMutation<TyreTeamCredential, void>({
    mutationFn: async payload => (await ApiInstance.post("/credentials/update", payload, ENV.tyreTeamBaseURL)).data,
    onSuccess: payload => {
      const credentials = typedQueryClient.getQueryData(DealersDashboardQueryKeys.tyreTeamCredentials(payload.dealer_location_id));
      if (!credentials?.length) return;

      const credentialIdx = credentials.findIndex(({ id }) => id === payload.id);
      if (credentialIdx === -1) return;

      typedQueryClient.setQueryData(
        DealersDashboardQueryKeys.tyreTeamCredentials(payload.dealer_location_id),
        credentials.with(credentialIdx, { ...credentials[credentialIdx], ...payload })
      );
    }
  });
